import React from 'react';

function YoutubeBrandingText({ text = 'YouTube' }) {
  return (
    <div className="absolute bottom-4 left-4 bg-black bg-opacity-70 px-4 py-2 rounded text-white text-xs font-semibold">
      {text}
    </div>
  );
}

export default YoutubeBrandingText;
